import React, { useState } from "react";
import { Popconfirm, Input } from "antd";

import images from "../../assets";

import {
  PrimaryButton,
  PendingButton,
  ApprovedButton,
  RejectedButton,
} from "../button";

const { TextArea } = Input;

const isImage = (url) => /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
const isPDF = (url) => /\.pdf$/i.test(url);

const TrustBadgeBox = ({ item, updateTrustBadge, trustBadgeData, ...rest }) => {
  const [rejectOpen, setRejectOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectLoading, setRejectLoading] = useState(false);

  const handleApprove = () => {
    const updatedTbData = trustBadgeData?.map((tb) =>
      tb?.url === item?.url ? { ...tb, status: "approved" } : tb
    );
    updateTrustBadge(updatedTbData, "approved");
  };

  const handleRejectConfirm = async () => {
    if (!rejectReason.trim()) return;
    try {
      setRejectLoading(true);
      const updatedTbData = trustBadgeData?.map((tb) =>
        tb?.url === item?.url ? { ...tb, status: "rejected" } : tb
      );
      // Pass reason as the 3rd parameter
      updateTrustBadge(updatedTbData, "rejected", rejectReason.trim());
      setRejectOpen(false);
      setRejectReason("");
    } finally {
      setRejectLoading(false);
    }
  };

  return (
    <div
      className="w-[456px] bg-white rounded-2xl border border-primary50 flex-col flex"
      {...rest}
    >
      <div className="w-full flex-col justify-start items-start gap-4 flex p-4">
        <div className="self-stretch h-[300px] w-full flex-col gap-4 flex relative">
          {isImage(item?.url) ? (
            <img
              className="h-full w-full object-cover rounded-xl"
              src={item?.signedUrl}
              alt="Trust Badge"
            />
          ) : isPDF(item?.url) ? (
            <iframe
              className="h-full w-full rounded-xl"
              src={item?.signedUrl}
              title="PDF Document"
            />
          ) : (
            <div className="h-full w-full flex justify-center items-center text-gray-500">
              Unsupported File Type
            </div>
          )}
          <div className="w-full bottom-[10px] absolute flex justify-center">
            <div className="h-11 p-4 bg-white rounded-full shadow justify-between items-center flex gap-5">
              <div className="#222222">{item?.documentType}</div>
              <div className="#222222">1 File</div>
            </div>
          </div>
        </div>

        <div className="w-full items-center gap-2 flex">
          <div>Status:</div>
          {item?.status === "active" || item?.status === "approved" ? (
            <ApprovedButton />
          ) : item?.status === "pending" ? (
            <PendingButton />
          ) : (
            <RejectedButton />
          )}
        </div>

        <PrimaryButton
          style={{
            width: "100%",
            height: "48px",
            fontSize: "14px",
            background: "#310048",
          }}
          text={"View"}
          iconalign="left"
          icon={images.eyeIcon}
          onClick={() => window.open(item?.signedUrl, "_blank")}
        />
      </div>

      <div className="bg-[#f5f6f7] w-full rounded-bl-2xl rounded-br-2xl p-4 justify-center items-center gap-5 flex flex-col">
        <Popconfirm
          title="Approve trust badge?"
          description="Are you sure to approve?"
          onConfirm={handleApprove}
          okText="Yes"
          cancelText="No"
        >
          <PrimaryButton
            style={{ background: "#17c964" }}
            text="Approve"
            iconalign="left"
            icon={images.checkWhiteIcon}
          />
        </Popconfirm>

        <div className="self-stretch justify-start items-center gap-3 flex">
          <Popconfirm
            title="Reject trust badge?"
            open={rejectOpen}
            onOpenChange={(open) => {
              setRejectOpen(open);
              if (!open) setRejectReason("");
            }}
            description={
              <div className="flex flex-col gap-2">
                <div>Are you sure to reject? Please provide a reason:</div>
                <TextArea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="Enter rejection reason..."
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  maxLength={300}
                />
              </div>
            }
            onConfirm={handleRejectConfirm}
            okText="Reject"
            cancelText="Cancel"
            okButtonProps={{
              disabled: !rejectReason.trim(),
              loading: rejectLoading,
            }}
          >
            <PrimaryButton
              style={{ background: "#f31260" }}
              text="Reject"
              iconalign="left"
              icon={images.rejectWhiteIcon}
            />
          </Popconfirm>

          <PrimaryButton
            style={{ background: "#f5a524" }}
            text="Queue"
            iconalign="left"
            icon={images.queueIcon}
          />
        </div>
      </div>
    </div>
  );
};

export default TrustBadgeBox;
